import { FileUpload } from '@mui/icons-material';
import { Avatar, Box, Typography } from '@mui/material';
import { useEffect, useState } from 'react';

import { useApi } from '../../hooks/useApi';
import { useUser } from '../../hooks/useUser';
import ImageEditorUpload from '../common/ImageEditorUpload';

const LogoUpload = () => {
  const { entity, refresh } = useUser();
  const api = useApi();
  const [logoUrl, setLogoUrl] = useState<string>('');

  // For multi-entity clients the selected entity is sent via the `X-Armhr-Client`
  // header (baked into the api client). The global `company.logo_url` comes from
  // the profile endpoint, which is not entity-aware, so we fetch the logo through
  // the entity-scoped `/company/logo` endpoint instead and refetch when the
  // selected entity changes.
  const entityId = entity?.id || entity?.client_id;

  useEffect(() => {
    let active = true;
    const fetchLogo = async () => {
      try {
        const response = await api.company.getLogo();
        if (active) setLogoUrl(response.results || '');
      } catch (error) {
        console.error(error);
      }
    };
    fetchLogo();
    return () => {
      active = false;
    };
  }, [api, entityId]);

  const handleLogoSave = async (blob: Blob) => {
    const formData = new FormData();
    formData.append('file', blob!, 'logo.png');

    try {
      const response = await api.company.uploadLogo(formData);
      setLogoUrl(response.results || '');
      refresh();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <ImageEditorUpload
      editorHeight={128}
      editorWidth={400}
      onSave={handleLogoSave}
    >
      <Box
        sx={{
          position: 'relative',
          margin: 'auto',
          width: 200,
          height: 64,
          overflow: 'hidden',
          '&:hover > .editor-overlay': {
            opacity: 1,
          },
          cursor: 'pointer',
        }}
      >
        <Avatar
          alt="Avatar"
          src={logoUrl || ''}
          variant={logoUrl ? 'square' : 'rounded'}
          sx={{ width: 200, height: 64, m: 'auto' }}
        >
          <FileUpload style={{ color: 'white', fontSize: '2rem' }} />
          <Typography variant="body1" color="white">
            Upload logo
          </Typography>
        </Avatar>
        <Box
          className="editor-overlay"
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0,0,0,0.65)',
            zIndex: 1000,
            opacity: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'opacity 0.3s',
            borderRadius: '4px',
          }}
        >
          <FileUpload style={{ color: 'white', fontSize: '2rem' }} />
          <Typography variant="body1" color="white">
            Upload logo
          </Typography>
        </Box>
      </Box>
    </ImageEditorUpload>
  );
};

export default LogoUpload;
